module.exports = __webpack_public_path__ + "media/images/soar/Plameet3-e329c79059d42aa6e2a3c4531cb371bc.png";